import { Axios } from "../hooks/useAxiosInstance";

export const Profile = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        post: async (data) => await postRecord(data),
        postForgetPassword: async (data) => await postForget(data),
        update: async (data, api_token) => await updatePassword(data, api_token)
    })

    async function postRecord(data) {
        const url = "admin/login";
        const option = {
            headers: {
                'token': '59200748-1234-2233-355-8c1281f7fcd2',
                'Content-Type': 'application/json'
            }
        }

        return await Axios.post(url, data, option);
    }
    async function postForget(data) {
        const url = "user/forgot-password";
        const option = {
            headers: {
                'token': '59200748-1234-2233-355-8c1281f7fcd2',
                'Content-Type': 'application/json'
            }
        }

        return await Axios.post(url, data, option);
    }

    async function updatePassword(data, api_token) {
        const url = "admin/change-password";
        const option = {
            headers: {
                'token': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.patch(url, data, option);
    }

    return apis();

})()
